import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/batches.css';

const formatDate = (value) => {
  if (!value) return '—';

  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);

  return Number.isNaN(date.getTime())
    ? '—'
    : date.toLocaleDateString();
};

const formatMoney = (value) =>
  Number(value || 0).toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatQuantity = (value) =>
  Number(value || 0).toLocaleString('en-IN', {
    maximumFractionDigits: 3,
  });

const getExpiryStatus = (expiryDate) => {
  if (!expiryDate) {
    return { label: 'No expiry', className: 'batch-status-neutral' };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const expiry = new Date(`${String(expiryDate).slice(0, 10)}T00:00:00`);
  const daysLeft = Math.ceil(
    (expiry.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (daysLeft < 0) {
    return { label: 'Expired', className: 'batch-status-expired' };
  }

  if (daysLeft <= 30) {
    return {
      label: daysLeft === 0 ? 'Expires today' : `Expires in ${daysLeft}d`,
      className: 'batch-status-warning',
    };
  }

  return { label: 'Valid', className: 'batch-status-valid' };
};

const BatchesTable = ({ batches = [], loading = false }) => {
  if (loading) {
    return (
      <div className="batches-table-state" role="status">
        Loading batches...
      </div>
    );
  }

  if (batches.length === 0) {
    return (
      <div className="batches-table-state">
        <h3>No batches found</h3>
        <p>Try changing your search or add a batch to get started.</p>
        <Link to="/user/batches/create" className="batch-primary-button">
          + Add Batch
        </Link>
      </div>
    );
  }

  return (
    <div className="batches-table-wrapper">
      <table className="batches-table">
        <thead>
          <tr>
            <th>Batch</th>
            <th>Product</th>
            <th>Purchase Date</th>
            <th>Expiry Date</th>
            <th>Received</th>
            <th>Remaining</th>
            <th>Purchase Price</th>
            <th>Selling Price</th>
            <th>Expiry Status</th>
          </tr>
        </thead>

        <tbody>
          {batches.map((batch) => {
            const expiryStatus = getExpiryStatus(batch.expiry_date);

            return (
              <tr key={batch.id}>
                <td>
                  <strong>{batch.batch_number}</strong>
                  <span className="batch-cell-secondary">
                    ID: {batch.id}
                  </span>
                </td>

                <td>
                  <strong>{batch.product_name}</strong>
                  <span className="batch-cell-secondary">
                    SKU: {batch.sku}
                  </span>
                </td>

                <td>{formatDate(batch.purchase_date)}</td>
                <td>{formatDate(batch.expiry_date)}</td>
                <td>{formatQuantity(batch.quantity_received)}</td>
                <td>
                  <strong>
                    {formatQuantity(batch.quantity_remaining)}
                  </strong>
                </td>
                <td>{formatMoney(batch.purchase_price)}</td>
                <td>{formatMoney(batch.selling_price)}</td>

                <td>
                  <span className={`batch-status ${expiryStatus.className}`}>
                    {expiryStatus.label}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BatchesTable;